import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { setAccessToken } from "../generic/authStore";

/** Keeps the axios-layer access token in sync with the OIDC auth state. */
export const AuthBridge = () => {
    const auth = useAuth();
    useEffect(() => {
        setAccessToken(auth.isAuthenticated ? auth.user?.access_token ?? null : null);
    }, [auth.isAuthenticated, auth.user]);
    return null;
};
